/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Noorganizationdescription3Inputs */

const zh_organizationsettings_noorganizationdescription3 = /** @type {(inputs: Organizationsettings_Noorganizationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你还没有加入任何组织。请先创建或加入一个组织，然后再管理成员。`)
};

const en_organizationsettings_noorganizationdescription3 = /** @type {(inputs: Organizationsettings_Noorganizationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have not joined any organization yet. Create or join one first, then manage members.`)
};

const es_organizationsettings_noorganizationdescription3 = /** @type {(inputs: Organizationsettings_Noorganizationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no te has unido a ninguna organización. Crea o únete a una primero, luego administra los miembros.`)
};

/**
* | output |
* | --- |
* | "You have not joined any organization yet. Create or join one first, then manage members." |
*
* @param {Organizationsettings_Noorganizationdescription3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_noorganizationdescription3 = /** @type {((inputs?: Organizationsettings_Noorganizationdescription3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Noorganizationdescription3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_noorganizationdescription3(inputs)
	if (locale === "en") return en_organizationsettings_noorganizationdescription3(inputs)
	return es_organizationsettings_noorganizationdescription3(inputs)
});
export { organizationsettings_noorganizationdescription3 as "organizationSettings_noOrganizationDescription" }